<span matSnackBarLabel>{{ data.message }}</span>
<div class="mat-simple-snackbar-action" matSnackBarActions>
	<button matSnackBarAction mat-button cm-mini-button (click)="close()">
		<span *ngIf="data.action; else icon">
			{{ data.action }}
		</span>
	</button>
</div>

<ng-template #icon>
	<ats-icon name="close"></ats-icon>
</ng-template>
